/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum FileType {
	File = 'file', // generic
	Image = 'image',
	Audio = 'audio',
	Video = 'video',
	Text = 'text',
	Pdf = 'pdf',
	Application = 'application',
}

export enum MimeType {
	Jpeg = 'image/jpeg',
}

export function getFileType(mimeType: string): string {
	const [type, subtype] = mimeType.split('/');
	let fileType: string;
	switch (type) {
		case FileType.Image:
			fileType = FileType.Image;
			break;
		case FileType.Audio:
			fileType = FileType.Audio;
			break;
		case FileType.Video:
			fileType = FileType.Video;
			break;
		case FileType.Text:
			fileType = FileType.Text;
			break;
		case FileType.Application:
			switch (subtype) {
				case FileType.Pdf:
					fileType = FileType.Pdf;
					break;
				default:
					fileType = FileType.File;
			}
			break;
		default:
			fileType = FileType.File;
	}

	return fileType;
}

export function bytesToMB(fileSize: number): number {
	return fileSize / 1024 / 1024;
}

/**
 * This converts the Feature Flag string to the array format required by the
 * file upload component.  See comment for "fileAttachSuffix$()".
 */
export function convertFileAttachSuffixes(spaceSeparatedString: string): string[] {
	if (!spaceSeparatedString || spaceSeparatedString.trim() === '') {
		return undefined;
	}
	if (spaceSeparatedString.trim() === '*') {
		return ['*'];
	}

	// Split the string by spaces:
	const result = spaceSeparatedString
		.trim()
		.split(/\s+/)
		.map((element) => '.' + element.toLowerCase());

	// If there's a ".*" in there, make the result just be [ '*' ]
	if (result.includes('.*')) {
		return ['*'];
	}

	// The file-chooser dialogs are forgiving about treating "jpg" as meaning "jpg" or "jpeg";
	// likewise for just "jpeg".  HOWEVER, we also have code that checks whether the user has
	// circumvented the extension list, and prevents uploads of other file types if so.
	// In order for THAT code to work, we need to be as forgiving with just seeing "jpg", or
	// just seeing "jpeg" in the extensions feature-flag as the file-chooser dialogs.  So...
	const JPG = '.jpg';
	const JPEG = '.jpeg';
	if (result.includes(JPG) && !result.includes(JPEG)) {
		result.splice(result.indexOf(JPG), 0, JPEG);
	} else if (result.includes(JPEG) && !result.includes(JPG)) {
		result.splice(result.indexOf(JPEG), 0, JPG);
	}
	return result;
}
